import styled from "styled-components";

const StyledTr = styled.tr``;

export const TableRow = (props: any) => {
  const { children } = props;

  return <StyledTr>{children}</StyledTr>;
};
